import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex align-center primary--text justify-space-between" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center justify-space-between"
}
const _hoisted_3 = {
  key: 1,
  class: "d-flex align-center justify-space-between"
}
const _hoisted_4 = {
  key: 2,
  class: "d-flex align-center justify-space-between"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = {
  key: 4,
  style: {"color":"#f76631"}
}
const _hoisted_7 = {
  key: 5,
  class: "d-flex pt-2"
}
const _hoisted_8 = { class: "mb-2 text-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_CreateBankAccount = _resolveComponent("CreateBankAccount")!
  const _component_MergeBankAccounts = _resolveComponent("MergeBankAccounts")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        cols: "12",
        class: "my-3 justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_primary, {
                block: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createBankAccountDialog = true)),
                disabled: !_ctx.currentUser.profile.configuration.bankAccount.write,
                "data-cy": "Bank-add"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" Ajouter ")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "8",
            class: "pl-2"
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_primary, {
                block: "",
                disabled: 
                        _ctx.bankAccountsToMerge.length < 2 ||
                        !_ctx.currentUser.profile.configuration.bankAccount.write
                    ,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mergeBankAccountDialog = true)),
                "data-cy": "Bank-merge"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode(" Fusionner ")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        class: "d-flex justify-center",
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankAccounts, (account, i) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              cols: _ctx.$vuetify.display.mobile ? '12' : '10',
              class: "my-0 pa-2",
              disabled: _ctx.isMergeDisabled(account),
              key: i + account.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  "data-cy": "BankAccount-Card",
                  class: "default_card ma-0 pa-4",
                  elevation: "0",
                  disabled: _ctx.isMergeDisabled(account),
                  "pa-0": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "2"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_component_v_checkbox, {
                                  disabled: _ctx.isMergeDisabled(account),
                                  key: i + account.id,
                                  class: "d-flex justify-center align-center pa-0 ma-0",
                                  onClick: _withModifiers(($event: any) => (_ctx.selectBankAccount(account)), ["stop"]),
                                  value: _ctx.isSelectedBankAccount(account)
                                }, null, 8, ["disabled", "onClick", "value"]))
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          cols: _ctx.$vuetify.display.mobile ? '8' : '6'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                style: {"font-weight":"bold","font-size":"16pt"}
                              }, _toDisplayString(_ctx.getBankAccountName(account)), 3)
                            ]),
                            (account.number)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Numéro : " + _toDisplayString(account.number), 1))
                              : _createCommentVNode("", true),
                            (account.iban && !account.iban.startsWith(account.name))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " IBAN : " + _toDisplayString(account.iban), 1))
                              : _createCommentVNode("", true),
                            (account.externalName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Nom externe : " + _toDisplayString(account.externalName), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_icon, {
                                size: "x-small",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode("$fa-upload")
                                ])),
                                _: 1
                              }),
                              _createTextVNode(_toDisplayString(_ctx.getOrigin(account)) + " " + _toDisplayString(" - " + account.bankTransactionCount + " transaction(s)"), 1)
                            ]),
                            (account.importStartDate)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  _createVNode(_component_v_icon, {
                                    size: "x-small",
                                    class: "mr-2"
                                  }, {
                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                      _createTextVNode("$fa-upload")
                                    ])),
                                    _: 1
                                  }),
                                  _createTextVNode("Date de reprise : " + _toDisplayString(_ctx.formatDate(account.importStartDate)) + " " + _toDisplayString(" - " +
                                    account.beforeImportStartDateBTCount +
                                    " transaction(s) avant"), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (account.currentError && account.currentError.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(account.currentError), 1))
                              : _createCommentVNode("", true),
                            (!account.bic)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createVNode(_component_v_icon, {
                                    class: "mr-2 mb-1",
                                    color: "red",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                                      _createTextVNode(" $oss-warning ")
                                    ])),
                                    _: 1
                                  }),
                                  _cache[14] || (_cache[14] = _createElementVNode("h4", { style: {"color":"red","font-weight":"normal"} }, "BIC manquant", -1))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["cols"]),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "py-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "fill-height"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "d-flex justify-end"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_menu, { location: "start" }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn_icon, _mergeProps({
                                          "data-cy": "BankAccount-options",
                                          icon: "$dots_vertical",
                                          ref_for: true
                                        }, props), null, 16)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list, {
                                          nav: "",
                                          density: "compact"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item, {
                                              onClick: ($event: any) => {
                                                    _ctx.selectedBankId = account.id;
                                                    _ctx.createBankAccountDialog = true;
                                                }
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  size: "small",
                                                  location: "start"
                                                }, {
                                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                    _createTextVNode("$oss-edit")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { "data-cy": "BankAccount-options-modification" }, {
                                                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                    _createTextVNode(" Modifier ")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            (
                                                    account.budgetInsightId &&
                                                    account.type !== 'CASH_BOX'
                                                )
                                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                  key: 0,
                                                  disabled: 
                                                    !_ctx.currentUser.profile.configuration.bankAccount
                                                        .write
                                                ,
                                                  onClick: ($event: any) => {
                                                    _ctx.toDisconnectBankAccount = account;
                                                    _ctx.disconnectBankAccountDialog = true;
                                                }
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                        _createTextVNode(" Déconnexion ")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_list_item_action, { class: "d-flex align-center" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          size: "small",
                                                          left: ""
                                                        }, {
                                                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                            _createTextVNode("$link_off")
                                                          ])),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled", "onClick"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_v_list_item, {
                                              disabled: 
                                                    !_ctx.currentUser.profile.configuration.bankAccount
                                                        .delete
                                                ,
                                              onClick: ($event: any) => {
                                                    _ctx.toDeleteBankAccount = account;
                                                    _ctx.deleteBankAccountDialog = true;
                                                }
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  size: "small",
                                                  location: "start"
                                                }, {
                                                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                    _createTextVNode("$oss-trash")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { "data-cy": "BankAccount-options-delete" }, {
                                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                    _createTextVNode(" Supprimer ")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["disabled", "onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                (account.budgetInsightId)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12",
                                      class: "d-flex align-center justify-center mx-0 px-0 py-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          disabled: !_ctx.enableBudgetInsight(account),
                                          rounded: "",
                                          elevation: "0",
                                          color: "new_red",
                                          onClick: _ctx.connectClicked,
                                          loading: _ctx.loading,
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(account.currentError ? "Réparer" : "Configuration") + " ", 1),
                                            _createVNode(_component_v_icon, {
                                              size: "small",
                                              location: "end"
                                            }, {
                                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                _createTextVNode("$build")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick", "loading"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["disabled"])
              ]),
              _: 2
            }, 1032, ["cols", "disabled"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["style"]),
      (_ctx.deleteBankAccountDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.deleteBankAccountDialog,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deleteBankAccountDialog) = $event)),
            title: "Supprimer",
            error: true,
            errorTextConfirmation: _ctx.getBankAccountName(_ctx.toDeleteBankAccount),
            onValid: _ctx.deleteBankAccount,
            validLoading: _ctx.deleteBankAccountLoading,
            width: "800px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h4", _hoisted_8, " Êtes-vous sûr(e) de vouloir supprimer le compte bancaire " + _toDisplayString(_ctx.getBankAccountName(_ctx.toDeleteBankAccount)) + " ? ", 1),
              (_ctx.toDeleteBankAccount.bankTransactionCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_v_alert, {
                      type: "error",
                      class: "mt-4",
                      "model-value": true,
                      variant: "text"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Vous supprimerez aussi les " + _toDisplayString(_ctx.toDeleteBankAccount.bankTransactionCount) + " transactions associées à ce compte. ", 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "errorTextConfirmation", "onValid", "validLoading"]))
        : _createCommentVNode("", true),
      (_ctx.disconnectBankAccountDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 1,
            modelValue: _ctx.disconnectBankAccountDialog,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.disconnectBankAccountDialog) = $event)),
            title: "Déconnecter un compte bancaire",
            onValid: _ctx.disconnectBankAccount,
            validLoading: _ctx.disconnectBankAccountLoading,
            width: "800px"
          }, {
            default: _withCtx(() => [
              _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "mb-2 text-center" }, " Êtes-vous sûr(e) de vouloir arreter la récupération automatique des flux bancaires du compte bancaire suivant ? ", -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.getBankAccountName(_ctx.toDeleteBankAccount)), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "onValid", "validLoading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_CreateBankAccount, {
        active: _ctx.createBankAccountDialog,
        "onUpdate:active": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.createBankAccountDialog) = $event)),
        companyId: _ctx.companyId,
        companyBudgetInsightId: _ctx.budgetInsightId,
        bankId: _ctx.selectedBankId,
        bankAccounts: _ctx.bankAccounts,
        onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.refresh())),
        onCloseDialog: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeDialog()))
      }, null, 8, ["active", "companyId", "companyBudgetInsightId", "bankId", "bankAccounts"]),
      (_ctx.mergeBankAccountDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 2,
            modelValue: _ctx.mergeBankAccountDialog,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.mergeBankAccountDialog) = $event)),
            title: "Fusionner",
            actions: _ctx.actions,
            width: "40vw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_MergeBankAccounts, {
                bankAccountsToMerge: _ctx.bankAccountsToMerge,
                companyId: _ctx.companyId,
                actions: _ctx.actions,
                onBankAccountsMerged: _cache[7] || (_cache[7] = ($event: any) => (_ctx.mergedBankAccounts()))
              }, null, 8, ["bankAccountsToMerge", "companyId", "actions"])
            ]),
            _: 1
          }, 8, ["modelValue", "actions"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}